
export const deputyColumns=[

    {
        field: 'id',
        filterable: true,
        width: 40,
        hidden:false,
        title: 'id'
    },
    {
        field: 'user',
        filterable: true,
        width: 40,
        hidden:false,
        title: 'Employee'
    },
    {
        field: 'substituteUser',
        filterable: true,
        width: 40,
        hidden:false,
        title: 'Stellvertretung'
    },
    {
        field: 'startDate',
        filterable: true,
        width: 40,
        hidden:false,
        title: 'startDate',
        filter: 'date',
        format: '{0:dd.MM.yyyy}',
    },  
    {
        field: 'endDate',
        filterable: true,
        width: 40,
        hidden:false,
        title: 'endDate',
        filter: 'date',
        format: '{0:dd.MM.yyyy}',
    },  
];